module.exports = __webpack_public_path__ + "static/media/desktop_sm.7190f823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop_sm.svg
// module id = 3076
// module chunks = 0